import { useEffect } from 'react';

import { Drawer } from '@mui/material';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { useGetInsightsAuthToken } from '../../react-query/useGetInsightsAuthToken';
import { usePreferences } from '../../react-query/usePreferences';
import { isViewingEngagementAtom } from '../insights/atoms';

import {
  detailDashParamsAtom,
  detailDashboardUrlAtom,
  detailDrawerOpenAtom,
  isDevDashboardAtom,
  selectedDashboardAtom,
} from './atoms';
import {
  DashboardMap,
  DashboardPriorityList,
  DashboardUrls,
} from './constants';
import { InsightsHeader } from './insightsHeader/InsightsHeader';
import { TableauDashboard } from './TableauDashboard';

export const VideaInsights = () => {
  const { data: prefs } = usePreferences();
  const isViewingEngagement = useAtomValue(isViewingEngagementAtom);
  const [selectedDashboard, setSelectedDashboard] = useAtom(
    selectedDashboardAtom,
  );
  const detailDashboardUrl = useAtomValue(detailDashboardUrlAtom);
  const isDevDashboard = useAtomValue(isDevDashboardAtom);

  const [isDetailDrawerOpen, setIsDetailDrawerOpen] =
    useAtom(detailDrawerOpenAtom);

  const setDetailDashParams = useSetAtom(detailDashParamsAtom);

  const {
    data: token,
    isError: isGetTokenError,
    refetch: refetchToken,
  } = useGetInsightsAuthToken();

  const defaultDashboard = isViewingEngagement
    ? 'ENGAGEMENT'
    : DashboardPriorityList.filter(
        (dashboard) => dashboard !== 'ENGAGEMENT',
      ).find(
        (dashboard) =>
          prefs?.enableInsights && prefs?.enableInsights?.includes(dashboard),
      );

  useEffect(() => {
    const isValidDashboard =
      (isViewingEngagement && DashboardMap.ENGAGEMENT === selectedDashboard) ||
      (!isViewingEngagement &&
        selectedDashboard &&
        Object.values(DashboardMap).includes(selectedDashboard) &&
        DashboardMap.ENGAGEMENT !== selectedDashboard);

    if (!isValidDashboard && defaultDashboard) {
      setSelectedDashboard(DashboardMap[defaultDashboard]);
    }
  }, [
    selectedDashboard,
    setSelectedDashboard,
    defaultDashboard,
    isViewingEngagement,
  ]);

  if (!defaultDashboard) {
    return;
  }

  return (
    <>
      <InsightsHeader />
      {/* Main dashboard */}
      <TableauDashboard
        dashboard={selectedDashboard || DashboardMap[defaultDashboard]}
        isErrorToken={isGetTokenError}
        refetchToken={refetchToken}
        token={token}
        url={
          isDevDashboard &&
          DashboardUrls[selectedDashboard || DashboardMap[defaultDashboard]]
            ?.dev
            ? DashboardUrls[selectedDashboard || DashboardMap[defaultDashboard]]
                .dev!
            : DashboardUrls[selectedDashboard || DashboardMap[defaultDashboard]]
                .prod
        }
      />

      {/* Detail dashboard */}
      <Drawer
        anchor="right"
        onClose={() => {
          setIsDetailDrawerOpen(false);
          setDetailDashParams({});
        }}
        open={isDetailDrawerOpen}
        sx={{ '.MuiDrawer-paper': { width: '75%' } }}
      >
        <TableauDashboard
          dashboard="PROVIDER_DETAIL"
          isErrorToken={isGetTokenError}
          refetchToken={refetchToken}
          token={token}
          url={detailDashboardUrl}
        />
      </Drawer>
    </>
  );
};
